var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('woot-button',{staticClass:"-ml-3 text-black-900 dark:text-slate-300",attrs:{"size":_vm.size,"variant":"clear","color-scheme":"secondary","icon":"list"},on:{"click":_vm.onMenuItemClick}})}
var staticRenderFns = []

export { render, staticRenderFns }